import { useState } from "react"
import { Toaster } from 'react-hot-toast'
import './Accomplishments.css'
import { Achievements } from './achievements/Achievements'
import { AccomplishmentsBar } from './leftBar/AccomplishmentsBar'
import { Rating } from './rating/Rating'

export const Accomplishments = () => {
	const [currentPage, setCurrentPage] = useState<'ACHIEVEMENTS' | 'RATING'>("ACHIEVEMENTS")

	const achievemntPage = () => {
		return <Achievements />
	}

	const ratingPage = () => {
		return <Rating />
	}

	return (
		<div className="accomplishments">
			<AccomplishmentsBar page={currentPage} setPage={setCurrentPage} />
			{currentPage === "ACHIEVEMENTS" ? achievemntPage() : ratingPage()}
			<div className='accomplishments-background'>
				<img src="/achievements/achievements_background.webp" alt="" />
			</div>
			<Toaster
				position="bottom-center"
				toastOptions={{
					duration: 2000,
				}}
			/>
		</div>
	)
}